import type { Filter } from 'modules/core/components/DataTable/types'

import { PULSE_ANSWER_FILTER_IDENTIFIER } from 'modules/performance_analytics/components/PerformanceInsightsSummaryDatatable/filters/pulseAnswerFilter'

import type { FilterOption, FilterState } from '../types'

function hasCategory(obj: unknown): obj is { category?: { options?: Array<{ value: unknown }> } } {
  return Boolean(obj && typeof obj === 'object' && 'category' in obj)
}

function isValidOption(option: unknown): option is { value: unknown } {
  return Boolean(option && typeof option === 'object' && 'value' in option)
}

export const getSelectedFilterAndOptionByIndex = (
  index: number,
  enabledFilters: Filter<unknown>[],
  availableFilters: Filter<unknown>[]
): FilterState => {
  const pulseAnswerFilter = (filter: Filter<unknown>) =>
    filter.filter.identifier === PULSE_ANSWER_FILTER_IDENTIFIER

  const pulseFilterAvailable: Filter<unknown> | undefined = availableFilters.find(pulseAnswerFilter)
  const pulseFilterEnabled: Filter<unknown> | undefined = enabledFilters.find(pulseAnswerFilter)
  const pulseFilter = pulseFilterAvailable || pulseFilterEnabled

  const parsedPulseFilter = pulseFilter as unknown
  const option = hasCategory(parsedPulseFilter)
    ? parsedPulseFilter.category?.options?.[index]
    : undefined

  const selectedOption: FilterOption | undefined = isValidOption(option) ? option : undefined

  return {
    pulseFilter,
    selectedOption,
    filterAlreadyEnabled: Boolean(pulseFilterEnabled),
  }
}
